import React from "react";
import { SiteSettings } from "../../models/shared/SiteSettings";
import { MarketSelectorButton } from "../MarketSelectorButton";

import logotypeIcon from "../../assets/images/logotype.svg";
import { FooterAside } from "./FooterAside";
import Button, { ButtonSize } from "../Buttons/Button";
import SanityLink, { checkLinkExists, renderLinkTitle } from "../SanityLink";
import { isNullOrWhiteSpace } from "../../shared/string";
import { formatPhoneNumberLink } from "../../utilities/links";

interface Props {
    siteSettings: SiteSettings;
}

export const GroupFooter = (props: Props) => {
    const siteSettings = props.siteSettings;

    if (!siteSettings?.footer) {
        return <footer key="footer" className="flex flex-col items-center bg-footer-bg text-footer-text-color"></footer>;
    }

    const { footer, siteContact } = siteSettings;

    const {
        contactCta,
        marketButtonTitle,
        linkSections
    } = footer || {};

    return (
        <footer key="footer" className="flex flex-col items-center bg-footer-bg text-footer-text-color">
            <div className="flex flex-col md:flex-row flex-wrap justify-center lg:justify-start items-center md:items-start flex-1 w-full max-w-screen-xl px-4 py-8 mx-auto md:px-8 md:py-16 lg:px-0">
                <div className="flex flex-0 flex-col items-start md:w-2/5 md:pl-4 lg:w-1/4 lg:pl-12 xl:pl-8">
                    <svg width={264} height={40} className="mb-8 md:mb-12 md:-ml-8 text-neutral-100 fill-current">
                        <use xlinkHref={logotypeIcon.url} />
                    </svg>
                    {!isNullOrWhiteSpace(siteContact.phoneNumber) &&
                        <div className="mb-6">
                            <h3 className="text-base uppercase text-footer-text-color">Press contact</h3>
                            <a href={formatPhoneNumberLink(siteContact.phoneNumber)} className="text-base text-footer-text-color no-underline hover:underline">{siteContact.phoneNumber}</a>
                        </div>
                    }
                    {!isNullOrWhiteSpace(siteContact.visitorAddress) &&
                        <div className="mb-6">
                            <h3 className="text-base uppercase text-footer-text-color">Visitor address</h3>
                            <p className="text-base text-footer-text-color m-0">{siteContact.visitorAddress}</p>
                        </div>
                    }
                    {((checkLinkExists(contactCta) && contactCta.title) || !!marketButtonTitle) &&
                        <div className="flex flex-col items-stretch">
                            {(checkLinkExists(contactCta) && contactCta.title) &&
                                <Button
                                    className="mb-4"
                                    color="primary-light"
                                    size={ButtonSize.Small}
                                    type="link"
                                    {...contactCta}
                                >
                                    {contactCta.title}
                                </Button>
                            }
                            {!!marketButtonTitle &&
                                <MarketSelectorButton title={marketButtonTitle} />
                            }
                        </div>
                    }
                </div>
                {!!linkSections?.length &&
                    <div className="flex flex-1 flex-wrap justify-start mt-10 md:w-3/5 md:mt-3 lg:w-3/4 lg:pl-24">
                        {linkSections.map((section, x) => (
                            <ul key={x} className="flex flex-col flex-0 w-full md:w-1/2 xl:w-1/4 mb-10 md:px-4 md:mt-0">
                                {section.links && section.links.map((link, y) => {
                                    const itemClass = y === 0 ? "mb-4" : "mb-2";
                                    const linkClass = y === 0
                                        ? "text-base text-footer-text-color uppercase font-bold no-underline hover:underline"
                                        : "text-lg text-neutral-100-dim no-underline hover:underline hover:text-footer-text-color";
                                    
                                    return (
                                        <li key={y} className={itemClass}>
                                            <SanityLink {...link} className={linkClass}>
                                                {renderLinkTitle(link)}
                                            </SanityLink>
                                        </li>
                                    );
                                })}
                            </ul>
                        ))}
                    </div>
                }
            </div>
            <FooterAside siteSettings={siteSettings} />
        </footer>
    );
};
